import ProductCard from "../components/ProductCard";
import { productsArray } from "../productsStore";
import { AgendaImage, EventsRectBg } from "../styles/Images";
import { EventsWrapper } from "../styles/Layouts";
import pinkRect from "../assets/images/pink-rect-header.png";
import lifeDrawingImg from "../assets/images/life-drawing-agenda.jpeg";

const Events = () => {
  return (
    <EventsWrapper>
      {productsArray.map((product, index) => (
        <EventsRectBg key={index} $bgImage={pinkRect}>
          <ProductCard product={product} />
        </EventsRectBg>
      ))}
      <AgendaImage src={lifeDrawingImg} alt="Life Drawing Agenda" />
    </EventsWrapper>
  );
};

export default Events;
